import {
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { AssessmentCrisisAlert } from '../../assessment/shared';

export const WhatWeCantTreat = () => (
  <>
    <Typography>
      Our psychiatrists provide medication management and supportive therapy
      together, so they're unable to treat patients looking for talk therapy
      only.
    </Typography>
    <Typography sx={{ my: 3 }}>
      Certain conditions are best treated with in-person care, or in-person and
      virtual care combined. As a virtual-only practice, we're unable to treat:
    </Typography>
    <List dense disablePadding>
      <ListItem disableGutters sx={{ py: 0 }}>
        <ListItemText primary="Schizophrenia" />
      </ListItem>
      <Divider sx={{ pt: 1, mb: 1 }} />
      <ListItem disableGutters sx={{ py: 0 }}>
        <ListItemText primary="Eating disorders" />
      </ListItem>
      <Divider sx={{ pt: 1, mb: 1 }} />
      <ListItem disableGutters sx={{ py: 0 }}>
        <ListItemText primary="Patients who feel they're at risk of killing themselves" />
      </ListItem>
      <Divider sx={{ pt: 1, mb: 1 }} />
      <ListItem disableGutters sx={{ py: 0 }}>
        <ListItemText primary="Patients who require treatments that must be administered in person" />
      </ListItem>
      <Divider sx={{ pt: 1, mb: 1 }} />
      <ListItem disableGutters sx={{ py: 0 }}>
        <ListItemText primary="Patients who've been hospitalized for a mental health condition in the last 6 months" />
      </ListItem>
    </List>
    <AssessmentCrisisAlert />
  </>
);
